module.exports = __webpack_public_path__ + "img/engravingOnTheSide@2x.e6728a6.jpg";